const $ = jQuery

class news {
  constructor () {
    this.$window                        = $(window)
    this.$document                      = $(document)
    this.pageNumber                     = 1
    this.loadMoreNewsSelector           = '#load-more'
    this.newsContainer                  = '#news-container'


    this.$document.on('click', this.loadMoreNewsSelector, (event) =>{
      const $clickedButton = $(event.currentTarget)
      
      let currentPage = ++this.pageNumber;
      let maxPage = $clickedButton.attr('data-max')
      let termID = $clickedButton.attr('data-category')
      $(this.newsContainer).addClass('loading');
      $(this.loadMoreNewsSelector).addClass('loading');

      $.ajax({
        type: 'POST',
        url: window.ajaxUrl,
        data: {
          action: 'load_more_news',
          page: currentPage,
          category: termID
        }
      }).success((response) => {
        if (response.trim()) {
          $(this.newsContainer).append(response);

          // Hide button if we've reached the last page
          if (currentPage >= maxPage) {
            $(this.loadMoreNewsSelector).hide();
          }
        } else {
          $(this.loadMoreNewsSelector).hide();
        }
        $(this.newsContainer).removeClass('loading');
        $(this.loadMoreNewsSelector).removeClass('loading');
      }).fail((response) => {
        console.log("Fail");
      });
    })
  }

  onWindowResize (windowWidth) {
    
  }
}

export default news